import { IntlMessageKeys } from '../../i18n'
import type { ReactNode } from 'react'
import { FormattedMessage as ReactIntlFormattedMessage } from 'react-intl'
import type { Props as ReactIntlFormattedMessageProps } from 'react-intl/src/components/message'

type FormattedMessageProps = ReactIntlFormattedMessageProps<Record<string, ReactNode>> & {
  id?: IntlMessageKeys
}

export default function FormattedMessage({ id, ...reset }: FormattedMessageProps) {
  return <ReactIntlFormattedMessage id={id} {...reset} />
}
